<template>
  <div class="d-contents">
    <Avatar
      v-for="user in contactsForShow"
      :key="user.id"
      size="24"
      :pic="get(user, 'files_urls.avatar_thumbnail')"
      :name="user.name"
      class="tender-contractors__avatar"
    />
    <div v-if="contacts.length > 4">+{{ $tc('invite', contacts.length - 4) }}</div>
  </div>
</template>

<script>
  import get from 'lodash.get';
  import Avatar from '@/components/avatars/Avatar';

  export default {
    name: 'ContractorContactsList',
    components: { Avatar },
    props: {
      contacts: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      contactsForShow() {
        return this.contacts.slice(0, 4);
      },
    },
    methods: {
      get,
    },
  };
</script>
